import { h } from 'preact'

import s from './IkkeOpptalt.module.css'
import { Message } from '../../../../../lib/intl/Message'
import { Profil } from '../../../shared/Decoration'

export function IkkeOpptalt() {
  return (
    <section class={s.ikkeOpptalt}>
      <h3>
        <Message id="opptelling-null-prosent-tittel" />
      </h3>
      <p>
        <Message id="opptelling-null-prosent-tekst" />
      </p>
      <Profil id="ikke-opptalt-profil" class={s.bunnDekor} inElement={true} />
    </section>
  )
}
